<template>
  <component :is="!loading && items.length ? 'section' : 'div'">
    <LoadingWidget v-if="loading" />

    <v-container v-else-if="items.length">
      <TitleWidget>
        {{ title }}
      </TitleWidget>

      <div class="mt-6 mt-sm-8 mt-md-10">
        <div v-if="!xsOnly" class="justify-center grid-list">
          <PropertyCard
            v-for="(item, keyItems) in parsedItems"
            :key="keyItems"
            v-bind="item"
            is-terrain
          />
        </div>

        <CarouselWidget v-else :items="parsedItems" v-bind="carouselSettings">
          <template #item="{ item }">
            <PropertyCard v-bind="item" is-terrain />
          </template>
        </CarouselWidget>
      </div>

      <ButtonWidget class="mt-8 mt-md-12" align="center" :to="path">
        Ver Todos
      </ButtonWidget>
    </v-container>
  </component>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import PropertyCard from "../cards/PropertyCard.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "properties",
  path: "/terrenos",
};

const _pagination = {
  itemsPerPage: 50,
  returnTotalItems: 1,
};

const _carouselSettings = {
  itemsToShow: {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1,
  },
  nav: true,
  navPositionY: 40,
};

const _data = {
  title: "Terrenos",
  loading: true,
  totalItems: 0,
  path: _config.path,
  items: [],
  carouselSettings: _carouselSettings,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    parsedItems() {
      return this.items
        .map((value) => ({ ...value, sort: Math.random() * 50 }))
        .sort((a, b) => a.sort - b.sort)
        .filter((item, index) => index < 8);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;
      this.items = [];

      const params = {
        ..._pagination,
        category: "Terreno, Terreno Comercial",
      };

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (data?.list?.length) {
              this.items = data.list;
              this.totalItems = data.totalItems;
            } else this.items = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    LoadingWidget,
    TitleWidget,
    PropertyCard,
    CarouselWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 20px 12px;
  grid-template-columns: repeat(auto-fit, 300px);

  @media screen and (max-width: 959.9px) {
    grid-template-columns: repeat(2, calc(50% - 6px));
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}
</style>
